import { emitter } from 'shared/helpers/mitt';
import { catalogue, accountApps, loadApps } from './customerToolsCatalogue';
import { CUSTOMER_TOOLS_REQUEST, CUSTOMER_TOOLS_SELECT, CUSTOMER_TOOLS_STATE, positiveId, scopeKey, acceptsSelection, selectionIndex } from './customerToolsState.mjs';
let serial = 0;
export default {
  data() { return { apolisSelectedAppId: null, apolisSession: `conversation-${++serial}` }; },
  computed: {
    apolisAccount() { return positiveId(this.$route.params.accountId); },
    apolisScope() {
      const params = this.$route.params;
      const routeId = positiveId(params.conversation_id ?? params.conversationId);
      const chatId = positiveId(this.currentChat?.id);
      const chatAccount = positiveId(this.currentChat?.account_id);
      if (!routeId || routeId !== chatId || chatAccount !== this.apolisAccount) return null;
      return scopeKey(this.apolisAccount, routeId);
    },
    dashboardApps() { return this.apolisScope ? accountApps(this.apolisAccount) : []; },
    activeIndex: {
      get() { return selectionIndex(this.dashboardApps, this.apolisSelectedAppId) + 1; },
      set(index) { this.apolisSelectedAppId = positiveId(this.dashboardApps[index - 1]?.id); },
    },
    apolisAvailability() {
      return {
        scope: catalogue.ready && catalogue.account === this.apolisAccount ? this.apolisScope : null,
        session: this.apolisSession,
        appIds: this.dashboardApps.map(app => positiveId(app.id)),
        activeAppId: this.activeIndex ? this.apolisSelectedAppId : null,
      };
    },
  },
  watch: {
    apolisAccount: { immediate: true, handler(account) { loadApps(account); } },
    apolisScope() { this.apolisSession = `conversation-${++serial}`; this.apolisSelectedAppId = null; },
    apolisAvailability: { deep: true, handler() { this.apolisPublish(); } },
    nativeDashboardApps: { deep: true, handler() { loadApps(this.apolisAccount); } },
    dashboardApps(apps) {
      if (catalogue.ready && this.apolisSelectedAppId && selectionIndex(apps, this.apolisSelectedAppId) < 0) this.apolisSelectedAppId = null;
    },
  },
  mounted() {
    emitter.on(CUSTOMER_TOOLS_SELECT, this.apolisSelect);
    emitter.on(CUSTOMER_TOOLS_REQUEST, this.apolisPublish);
    this.apolisPublish();
  },
  beforeUnmount() {
    emitter.off(CUSTOMER_TOOLS_SELECT, this.apolisSelect);
    emitter.off(CUSTOMER_TOOLS_REQUEST, this.apolisPublish);
    emitter.emit(CUSTOMER_TOOLS_STATE, { ...this.apolisAvailability, scope: null, appIds: [], activeAppId: null });
  },
  methods: {
    apolisPublish() { emitter.emit(CUSTOMER_TOOLS_STATE, this.apolisAvailability); },
    apolisSelect(request) {
      if (!acceptsSelection(request, this.apolisAvailability, this.dashboardApps)) return;
      this.onDashboardAppTabChange(selectionIndex(this.dashboardApps, request.appId) + 1);
      // Synchronous acknowledgment lets the sidebar dismiss only after selection.
      this.apolisPublish();
    },
  },
};
